// ! Copyright (c) 2024, Brandon Ramirez, brr.dev

import React from 'react';
import { DarkModeContextProps } from './DarkModeContext.types';

export const DarkModeContext = React.createContext<
    DarkModeContextProps | undefined
>(undefined);
